<template>
  <v-container class="pa-0">
    <h3 class="modal-title pb-3">Start a Discussion or Ask a Question</h3>
    <hr class="thick" />
    <v-form ref="newQuestionForm" v-model="form.valid">
      <amaze-editor
        :rules="form.question"
        label="Discussion or Question*"
        v-model="question"
        required
      ></amaze-editor>
      <v-btn
        class="ml-0"
        @click="createNewCard()"
        color="primary"
        :disabled="submitting"
        >Create Post</v-btn
      >
      <v-btn @click="returnToGroup()" flat outline>Cancel and Close</v-btn>
    </v-form>
  </v-container>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
::v-deep form {
   .v-input__slot {
     label {
        font-size: 15px;
        line-height: 1.5em;
        font-weight: bolder;
     }
   }
 }
</style>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import cardMixin from "@/mixins/cardMixin.js";
import cardCrudMixin from "@/mixins/cardCrudMixin.js"

export default {
  mixins: [cardMixin, cardCrudMixin],
  data() {
    return {
      question: "",
      submitting: false,
      form: {
        valid: false,
        question: [
          v => !!v || "Please enter a Discussion or Question.",
          v =>
            (v && (v || "").length < 65535) ||
            "Please limit your Discussion or Question to 65535 characters or less."
        ]
      }
    };
  },
  mounted() {
    const returnRoute = "/group/" + this.$route.params.id;
    this.$emit('setReturnRoute', returnRoute);
  },
  computed: {
    summary: function () {
      return this.createSummary(this.question) || "";
    }
  },
  methods: {
    createNewCard() {
      if (this.$refs.newQuestionForm.validate()) {
        const groupId = this.$route.params.id;
        const newCard = {
          name: "My Great Card",
          card_type_id: 1,
          user_id: this.$auth.user().id,
          allow_comments: 1,
          allow_likes: 1,
          groups: [groupId],
          summary: this.createSummary(this.question),
          card: {
            question: this.question
          }
        };

        this.submitting = true;
        this.$http.post("cards", newCard).then(
          response => {
            EventBus.$emit("refresh-cards", groupId, true);
            this.returnToGroup();
          },
          response => {
            console.log("Error creating card.");
          }
        );
      } else {
        this.$store
          .commit("updateMessage", {
            message: "Unable to start a new discussion or question.",
            snackbar: true
          })
          .finally(() => {
            this.submitting = false;
          });
      }
    }
  }
};
</script>
